// This file was automatically generated from appchart.dialog.referralHistory.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.referralHistory');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.referralHistory.ordersTable = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><div class="referralDateHeader">Referral Date</div><div class="referralConsultantHeader">Consultant</div><div class="referralDetailsHeader">Reason for Consultation</div></div>');
  var referralOrderList2684 = opt_data.referralOrders;
  var referralOrderListLen2684 = referralOrderList2684.length;
  for (var referralOrderIndex2684 = 0; referralOrderIndex2684 < referralOrderListLen2684; referralOrderIndex2684++) {
    var referralOrderData2684 = referralOrderList2684[referralOrderIndex2684];
    output.append('<div class="el8FieldSection"><div class="referralDate">', (soy.$$escapeHtml(referralOrderData2684.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(referralOrderData2684.documentDate)) : ''), '</div><div class="referralConsultant">', (referralOrderData2684.physician) ? soy.$$escapeHtml(referralOrderData2684.physician.fullName) + ' ' + ((referralOrderData2684.physician.phone) ? '<span class="el8AppColor">(' + soy.$$escapeHtml(referralOrderData2684.physician.phone) + ')</span>' : '') : '', '</div><div class="referralDetails">', soy.$$escapeHtml(referralOrderData2684.clinicalReason), '</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.referralHistory.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer">', (opt_data.specialtyName) ? '<h3>Referral History for ' + soy.$$escapeHtml(opt_data.specialtyName) + '</h3>' : '<h3>Referral History</h3>', '<div class="spacer el8StandardFontSize">');
  el8.template.appchart.dialog.referralHistory.ordersTable(opt_data, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};
